import defaultLogoAsset from '../assets/agm-logo.svg';
import { LogoConfig } from '../types';

const LEGACY_REMOTE_LOGO = 'https://i.ibb.co/vzPRY40P/agm-logo.png';

export const getResolvedLogoImageUrl = (logoConfig?: LogoConfig | null) => {
  const imageUrl = logoConfig?.imageUrl?.trim();
  if (!imageUrl || imageUrl === LEGACY_REMOTE_LOGO) {
    return defaultLogoAsset;
  }
  return imageUrl;
};

